define('lq/events/actions/officeAddinLoginCommand',[
    'underscore',
    'lq',
    'lq/events/actions/eventAction'
], function (_, lq, EventAction) {
    'use strict';

    // reference: https://dev.office.com/reference/add-ins/outlook/1.5/Office

    // https://learn.microsoft.com/en-us/exchange/client-developer/exchange-web-services/how-to-authenticate-an-ews-application-by-using-oauth
    // https://learn.microsoft.com/en-us/office/dev/add-ins/outlook/authentication
    // https://learn.microsoft.com/en-us/office/dev/add-ins/develop/overview-authn-authz
    // https://learn.microsoft.com/en-us/office/dev/add-ins/develop/enable-nested-app-authentication-in-your-add-in

    // https://app.unpkg.com/@azure/msal-browser

    var initialized = false;
    var initializing = false;
    var afterInitialization = [];

    function OfficeAddinLoginCommand(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(OfficeAddinLoginCommand, EventAction);

    OfficeAddinLoginCommand.typeName = 'OfficeAddinLoginCommand';

    // unable to batch for now, because requesting a token is async
    OfficeAddinLoginCommand.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    OfficeAddinLoginCommand.prototype.execute = function (continuation) {
        var self = this;

        if (initialized)
            self.startLogin(continuation);
        else {
            afterInitialization.push(self.startLogin.bind(self, continuation));

            if (!initializing) {
                initializing = true;

                require([
                    'https://unpkg.com/@azure/msal-browser@4.15.0/lib/msal-browser.js',
                    'https://appsforoffice.microsoft.com/lib/1/hosted/Office.js',
                ], function (msal) {
                    self.msal = msal;

                    Office.onReady(function () {
                        initialized = true;

                        _.each(afterInitialization,
                            function (afterInitialization) {
                                afterInitialization();
                            });
                    })
                });
            }
        }
    };

    OfficeAddinLoginCommand.prototype.loginCallback = function (result, continuation) {
        var self = this;
        var returnUrl = this.piping.queryString.getValueOf('ReturnUrl');

        if (result.status === 'Success') {
            returnUrl = returnUrl || lq.getTenantUrl('');

            if (self.isUserLoggedInEventEnabled())
                self.refreshCsrfTokenForNewUser(function () {
                    self.triggerUserLoggedInEvents(continuation, returnUrl);
                });
            else
                window.location = lq.safeRedirectUrl(returnUrl, lq.getTenantUrl(''));
        }
        else {
            if (result.status === 'InvalidCredentials' || result.status === 'UserNotFound')
                self.handleError('invalidCredentials', 'The username or password provided is incorrect.', continuation);
            else if (result.status === 'UserLoginNotAllowed')
                self.handleError('userLoginNotAllowed', 'The user is not allowed to log in.', continuation, result.userId);
            else if (result.status === 'AccountLocked')
                self.handleError('accountLocked', 'Your account has been locked out because of too many invalid login attempts.', continuation);
            else
                alert('Unable to login.');
        }
        if (result.eventsToExecute) {
            _.each(result.eventsToExecute, function (eventName) {
                self.piping.eventing.publish(eventName, self.eventSource, null, continuation, null);
            });
        }
    };

    OfficeAddinLoginCommand.prototype.doLogin = function (userAccount, continuation) {
        var self = this;

        self.piping.dispatcher.dispatch('Outlook/LogIn',
            {
                actionId: self.piping.actionId,
                commandId: self.eventData.commandId,
                accessToken: userAccount.accessToken,
                itemId: Office.context.mailbox.item.itemId
            })
            .then(function (result) {
                self.loginCallback(result, continuation);
            });
    }

    OfficeAddinLoginCommand.prototype.startLogin = function (continuation) {
        var self = this;

        self.msal.createNestablePublicClientApplication({
            auth: {
                clientId: self.eventData.officeAddinClientId,
                authority: "https://login.microsoftonline.com/" + (self.eventData.officeAddinTenant || 'common')
            },
        })
            .then(function (pca) {
                var tokenRequest = {
                    scopes: ["User.Read", "openid", "profile", "email"],
                };

                pca.acquireTokenSilent(tokenRequest)
                    .then(function (userAccount) {
                        self.doLogin(userAccount, continuation);
                    })
                    .catch(function (error) {
                        console.log('Failed to get Office token silently: ' + error);

                        pca.acquireTokenPopup(tokenRequest)
                            .then(function (userAccount) {
                                self.doLogin(userAccount, continuation);
                            })
                            .catch(function (error) {
                                throw new Error('Failed to get Office token: ' + error);
                            })
                    })
            })
            .catch(function (error) {
                throw new Error('Failed to get Office token: ' + error);
            })
    };

    OfficeAddinLoginCommand.prototype.handleError = function (eventName, defaultMessage, continuation, eventArg) {
        if (this.eventIsEnabled(eventName)) {
            this.triggerEvent(eventName, continuation, eventArg);
        } else {
            console.log('Error: ' + defaultMessage);
            throw new Error(defaultMessage); // alert does not work in Office addin, so just throw the error
            //continuation();
        }
    };

    return OfficeAddinLoginCommand;
});
